var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('toolbar-option',[_c('template',{slot:"primary"},[_c('toggle',{on:{"change":function($event){return _vm.setChangedData(true)}},model:{value:(_vm.isChecked),callback:function ($$v) {_vm.isChecked=$$v},expression:"isChecked"}})],1)],2)}
var staticRenderFns = []

export { render, staticRenderFns }